import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useOnboarding = () => {
  const { user } = useAuth();
  const [hasSeenOnboarding, setHasSeenOnboarding] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setHasSeenOnboarding(null);
      setLoading(false);
      return;
    }

    fetchOnboardingStatus();
  }, [user]);

  const fetchOnboardingStatus = async () => {
    if (!user) return;

    try {
      const { data, error } = await supabase
        .from('user_settings')
        .select('has_seen_onboarding')
        .eq('user_id', user.id)
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('Error fetching onboarding status:', error);
        setHasSeenOnboarding(false);
      } else if (data) {
        setHasSeenOnboarding(data.has_seen_onboarding);
      } else {
        setHasSeenOnboarding(false);
      }
    } catch (error) {
      console.error('Error in fetchOnboardingStatus:', error);
      setHasSeenOnboarding(false);
    } finally {
      setLoading(false);
    }
  };

  const completeOnboarding = async () => {
    if (!user) return;

    try {
      const { error } = await supabase
        .from('user_settings')
        .upsert({
          user_id: user.id,
          has_seen_onboarding: true,
        });

      if (error) {
        console.error('Error completing onboarding:', error);
      } else {
        setHasSeenOnboarding(true);
      }
    } catch (error) {
      console.error('Error in completeOnboarding:', error);
    }
  };

  return {
    hasSeenOnboarding,
    loading,
    completeOnboarding,
  };
};
